<template>
  <div style="width: 100%">
    <div class="mychat_send_msg_con">
      <div class="mychat_send_msg">
        <div>
          <textarea
            class="chat_in"
            placeholder="请输入内容"
            v-model="message"
          ></textarea>
        </div>

        <div style="text-align: right">
          <el-button type="primary" @click="sendWsMessage">发送</el-button>
        </div>
      </div>
    </div>

    <!-- <div class="mychat_con">
      <div
        v-for="msg in messages"
        :class="['mychat_item', msg.senderId === $store.state.user.id ? 'send' : 'rec']"
      >
        <img :src="msg.userImage" class="mychat_uimg" />
        <div
          :class="['mychat_item_con', msg.senderId === $store.state.user.id ? 'send' : 'rec']"
        >
          {{ msg.content }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { sendMessage, sendGroupMessage } from "../api/ws";

export default {
  name: "mychat",
  data() {
    return {
      message: "",
      messages: [],
      ws: null, // WebSocket实例
    };
  },
  props: {
    // 聊天类型，single 单聊 group 群聊
    type: {
      type: String,
      default: "single",
    },
  },
  computed: {
    ...mapState({
      my: (state) => state.user,
    }),
  },
  mounted() {},
  methods: {
    goTome() {
      this.$router.push({ name: "me" });
    },
    addfriend() {
      var that = this;
      that.$router.push({ name: "addfriend", params: { refresh: true } });
    },
    mymsg() {
      var that = this;
      that.$router.push({ name: "mymsg", params: { refresh: true } });
    },

    sendWsMessage() {
      if (this.type == "single") {
        sendMessage(this.message);
      } else {
        sendGroupMessage(this.message);
      }

      this.message = ""; // 清空输入框
      setTimeout(function () {
        var div = document.getElementById("magBox");
        div.scrollTop = div.scrollHeight;
      }, 50);
    },
  },
};
</script>

<style>
.mychat_item_con_send {
  margin-right: 10px;
  margin-top: 10px;
  margin-left: 200px;
  color: #333333;
  font-size: 16px;
  background-color: #b2e394;
  padding: 10px;
  border-radius: 6px;
}

.mychat_item_send {
  display: flex;
  margin-top: 15px;
  flex-direction: row-reverse;
}

.mychat_item_con_rec {
  margin-left: 10px;
  margin-top: 10px;
  margin-right: 200px;
  color: #333333;
  font-size: 16px;
  background-color: #b2e394;
  padding: 10px;
  border-radius: 6px;
}

.mychat_uimg {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.mychat_item_rec {
  display: flex;
  margin-top: 15px;
}

.chat_in:focus {
  outline: none;
}

.chat_in {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /*Firefox*/
  -webkit-box-sizing: border-box; /*Safari*/
  font-size: 16px;
  height: 80px;
  border: none;
}

.mychat_send_msg_con {
  /* position: absolute; */

  /* left: 160px;
  right: 40px; */
  bottom: 0px;
  background-color: white;
}

.mychat_send_msg {
  border: solid 1px #2683be;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.mychat_con {
  margin-top: 20px;
  background-color: white;
  padding: 10px;
  margin-bottom: 400px;
}

.mychat_tip_noac {
  color: #707070 !important;
}

.mychat_tip {
  font-size: 18px;
  color: #2683be;
}

.mychat_top_bar {
  display: flex;
  align-items: center;
}
</style>
